import React from "react";
import PrismicRichText from "../components/PrismicRichText";
import styled from "styled-components";
import { get } from "lodash";
import { useDispatch } from "react-redux";

const StlSection = styled.section`
  margin-top: 70px;
  width: 100%;
  height: 100%;
  min-height: 535px;

  .hero-img {
    width: 100%;
    max-width: 800px;
  }

  .pill-shape {
    background: #e0fc01;
    color: #0077d6;
    border-radius: 44px;
    padding: 5px 15px;
    font-family: "Dinamit-Bold";
    font-size: 14px;
    white-space: nowrap;
  }

  .dialog-button {
    background: none;
    border: none;
    padding: 0;
    font-family: "Averta Bold";
    color: white;
    font-size: 16px;
    font-style: italic;
    text-decoration: underline;
    margin-top: 20px;
    cursor: pointer;
  }

  .copy {
    color: white;
    line-height: 0.9;
    padding: 25px;
    position: relative;
    bottom: 37px;

    &.wrapper {
      max-width: 1500px;
    }

    h1 {
      font-size: 80px;
      margin-bottom: 15px;
    }

    p {
      font-family: "Averta Bold";
      line-height: 1.3;
    }

    .logo {
      position: relative;
      width: 100px;
      left: 200px;
      top: 60px;
    }
  }

  @media only screen and (min-width: 600px) {
    padding-top: 0;

    .copy {
      p {
        max-width: 400px;
      }
    }
  }

  @media only screen and (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    .hero-img {
      order: 2;
    }
  }

  @media only screen and (min-width: 900px) {
    .copy {
      padding-left: 100px;
    }
  }

  @media only screen and (min-width: 601px) {
    bottom: 31px;
  }

  @media only screen and (min-width: 1200px) {
    padding: 40px 0;
    .copy {
      h1 {
        font-size: 140px;
        margin-bottom: 30px;
      }

      p {
        font-size: 24px;
        max-width: 600px;
        margin-top: 30px;
      }

      .dialog-button {
        font-size: 20px;
        margin-top: -30px;
      }

      .logo {
        width: 200px;
        left: 400px;
        top: 130px;
      }
    }

    .pill-shape {
      font-size: 24px;
    }
  }
`;

export default function D9HempHero(slice) {
  const dispatch = useDispatch();
  const copy = get(slice, "primary.copy");
  const buttonCopy = get(slice, "primary.button_copy[0].text");
  const logo = get(slice, "primary.logo.url");
  const heroImg = get(slice, "primary.hero_image.url");

  const openDialog = () => {
    dispatch({
      type: "DIALOG/SHOW",
      id: "d9_hemp_dialog",
    });
  };

  return (
    <StlSection>
      <img className="hero-img" src={heroImg} alt="gummies" />
      <div className="wrapper copy relative">
        <img className="logo" alt="" role="presentation" src={logo} />
        <PrismicRichText render={copy} />
        <button onClick={openDialog} className="dialog-button">
          {buttonCopy}
        </button>
      </div>
    </StlSection>
  );
}
